import { portalScreenContext } from '../../app/telemetry/portalTelemetry';
import { usePortalScreen } from '../../app/telemetry/usePortalTelemetry';
import { useMsal } from "@azure/msal-react";
import { UserRole } from "../../app/enums/userRole";
import { IdTokenClaims } from "../../app/models/account/idTokenClaims";
import AffiliateMembershipRenewForm from "./AffiliateMembershipRenewForm";
import NonAffiliateMembershipRenewalForm from "./NonAffiliateMembershipRenewalForm";

export default function MembershipRenewForm() {

  const { instance } = useMsal();
  const userRoles = (instance.getActiveAccount()?.idTokenClaims as unknown as IdTokenClaims).extension_portalcrm_userType.split(',');

  usePortalScreen(portalScreenContext('MembershipRenewForm'), undefined, true);

  return (
    <>
      {userRoles.filter(x => x === UserRole.FAM_AFFILIATE).length > 0 &&
        <AffiliateMembershipRenewForm />
      }

      {userRoles.filter(x => x === UserRole.FAM_AFFILIATE).length === 0 &&
        <NonAffiliateMembershipRenewalForm />
      }
    </>
  );
};
